import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LegalModule } from './legal/legal.module';
import { SharedModule } from './shared/shared.module';
import { ANALYTICS_ADAPTER, NoopAnalyticsAdapter } from './services/analytics.service';
import { BASE_PATH } from '../generated/users/variables';
import { appApiBase } from './config/api-base';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, HttpClientModule, FormsModule, IonicModule.forRoot(), SharedModule, LegalModule, AppRoutingModule],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ANALYTICS_ADAPTER, useClass: NoopAnalyticsAdapter },
    { provide: BASE_PATH, useValue: appApiBase() },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
